import { render } from "./PurchaseLinesEditor.vue?vue&type=template&id=2c105fcd&scoped=true"
import script from "./PurchaseLinesEditor.vue?vue&type=script&lang=js"
export * from "./PurchaseLinesEditor.vue?vue&type=script&lang=js"

import "./PurchaseLinesEditor.vue?vue&type=style&index=0&id=2c105fcd&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c105fcd"]])

export default __exports__